module.exports = __webpack_public_path__ + "media/flags/cv-cec36e11.svg";